import { PlanDetails } from './types'

export const SYSTEM_SEND_STRIPE_ID = '14535'

export const planDetails: PlanDetails[] = [
  {
    plan: 'Basic',
    details: [
      { detail: '$2.75/Heartfelt Prompting Cards' },
      {
        detail: 'Automated Sends Tiered pricing:',
        innerDetails: [
          { detail: '$2.75 per card' },
          { detail: '$2.50 per card for 25+' },
          { detail: '$2.25 per card for 50+' },
          { detail: '$2.00 per card for 100+' },
        ],
      },
      { detail: 'Full retail price on gifts' },
      { detail: 'Enhanced Storage' },
    ],
  },
  {
    plan: 'Card A Day',
    details: [
      { detail: '30 Heartfelt Prompting Cards every month**' },
      { detail: '$2.00 per card beyond 30 Heartfelt Prompting Cards' },
      {
        detail: 'Automated Sends Tiered pricing:',
        innerDetails: [
          { detail: '$2.00 per card' },
          { detail: '$1.85 per card for 25+' },
          { detail: '$1.70 per card for 50+' },
          { detail: '$1.55 per card for 100+' },
        ],
      },
      { detail: '20 percent discount on gifts*' },
      { detail: 'Enhanced storage' },
    ],
  },
  {
    plan: 'Unlimited',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards (Postage included!)' },
      {
        detail: 'Automated Sends Tiered pricing:',
        innerDetails: [
          { detail: '$1.75 per card' },
          { detail: '$1.60 per card for 25+' },
          { detail: '$1.45 per card for 50+' },
          { detail: '$1.30 per card for 100+' },
        ],
      },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premium storage' },
    ],
  },
  {
    plan: 'Unlimited +100',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards (Postage included!)' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '100 Automated Sends***' },
      {
        detail: '$1.25 per additional Automated Send (postage not included)***',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premium Storage' },
    ],
  },
  {
    plan: 'Unlimited +250',
    details: [
      { detail: 'Unlimited Heartfelt Prompting Cards (Postage included!)' },
      { detail: '30 percent discount on gifts*' },
      { detail: 'Premier discounted shipping on top-selling gifts' },
      { detail: '250 Automated Sends***' },
      {
        detail: '$1.00 per additional Automated Send (postage not included)***',
      },
      { detail: 'Expense account required on this plan' },
      { detail: 'Premium Storage' },
    ],
  },
  {
    plan: 'Enterprise',
    details: [
      { detail: 'Unlimited Heartfelt Single Card Sends Including Stamps' },
      { detail: '$1.75/Group and Scheduled Cards' },
      { detail: '30% Discount on Gifts *' },
      { detail: 'Includes All Card Types' },
      { detail: '100 Free Cards Toward Group Sends Per Month' },
      { detail: 'Premium Storage' },
      { detail: 'Loyalty Rewards' },
      { detail: '+ Enhanced Plan Features' },
    ],
  },
]
